import React, { useState, useCallback } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Layout from './Layout';
import Home from './pages/Home';
import Shop from './pages/Shop';
import Care from './pages/Care';
import About from './pages/About';
import CartDrawer from './components/CartDrawer';
import Toast from './components/Toast';
import './index.css';

function App() {
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'success') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => {
      removeToast(id);
    }, 4000);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  const handleAddToCart = useCallback((product) => {
    setCart(prev => {
      const existing = prev.find(item => item.id === product.id);
      if (existing) {
        return prev.map(item => 
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
    addToast(`${product.name} added to your library.`);
    setIsCartOpen(true);
  }, [addToast]);

  const updateQuantity = useCallback((id, quantity) => {
    if (quantity < 1) {
      removeFromCart(id);
      return;
    }
    setCart(prev => prev.map(item => 
      item.id === id ? { ...item, quantity } : item
    ));
  }, []);

  const removeFromCart = useCallback((id) => {
    const item = cart.find(i => i.id === id);
    setCart(prev => prev.filter(item => item.id !== id));
    if (item) addToast(`${item.name} removed.`, 'info');
  }, [cart, addToast]);

  return (
    <HashRouter>
      <Layout 
        cartCount={cart.reduce((acc, item) => acc + item.quantity, 0)} 
        onOpenCart={() => setIsCartOpen(true)}
      >
        <Routes>
          <Route index element={<Home onAddToCart={handleAddToCart} />} />
          <Route path="shop" element={<Shop onAddToCart={handleAddToCart} />} />
          <Route path="care" element={<Care />} />
          <Route path="about" element={<About />} />
          <Route path="checkout" element={<div className="pt-40 text-center text-linen font-serif text-3xl h-screen">Secure Checkout Platform Under Maintenance</div>} />
        </Routes>
      </Layout>

      <CartDrawer 
        isOpen={isCartOpen} 
        onClose={() => setIsCartOpen(false)}
        cart={cart}
        updateQuantity={updateQuantity}
        removeFromCart={removeFromCart}
      />

      <Toast toasts={toasts} removeToast={removeToast} />
    </HashRouter>
  );
}

export default App;